var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(-121.049 0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    transform: "translate(121.049 -0.3)",
    fill: "#fff",
    stroke: "#0072b1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M0,7.433A2.278,2.278,0,0,1,.74,5.688,2.716,2.716,0,0,1,2.665,5a2.635,2.635,0,0,1,1.883.677A2.386,2.386,0,0,1,5.289,7.5a2.228,2.228,0,0,1-.719,1.692,2.721,2.721,0,0,1-1.946.7H2.6a2.589,2.589,0,0,1-1.883-.7A2.345,2.345,0,0,1,0,7.433Zm.275,18.51V11.812h4.7V25.943Zm7.3,0h4.7V18.052a2.754,2.754,0,0,1,1.068-2.359,2.3,2.3,0,0,1,1.513-.5q2.369,0,2.369,3.194v7.552h4.7v-8.1a6.809,6.809,0,0,0-1.481-4.749,5.051,5.051,0,0,0-3.914-1.618,4.8,4.8,0,0,0-4.252,2.348v.042h-.021l.021-.042v-2.01h-4.7q.042.677.042,4.21T7.573,25.943Z",
    transform: "translate(135.005 9.027)",
    fill: "#0072b1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinShare);
export default __webpack_public_path__ + "static/media/linkedin-share.b02eebc1159750d7aa40cfd2519ef02c.svg";
export { ForwardRef as ReactComponent };